// extracted by mini-css-extract-plugin
module.exports = {"root":"view-header_root_3jAkV","button":"view-header_button_2f9cK","active":"view-header_active_31c0T","btnExport":"view-header_btnExport_SifrQ","mr":"view-header_mr_1Z9Ht"};